import { DotThanhToanInput } from '@/types/schemas/dot-thanh-toan.type';
import { useDotThanhToan } from '@/hooks/queries';

export const usePaymentInstallment = () => {
  const {
    paymentInstallments,
    isLoading,
    addPaymentInstallment: addDotThanhToan,
    updatePaymentInstallment: updateDotThanhToan,
    deletePaymentInstallment: deleteDotThanhToan,
    refreshPaymentInstallments
  } = useDotThanhToan();

  const addPaymentInstallment = async (data: DotThanhToanInput) => {
    try {
      await addDotThanhToan(data);
    } catch (error) {
      console.error('Error adding payment installment:', error);
      throw error;
    }
  };

  const updatePaymentInstallment = async (data: DotThanhToanInput & { uuid: string }) => {
    try {
      await updateDotThanhToan(data.uuid, data);
    } catch (error) {
      console.error('Error updating payment installment:', error);
      throw error;
    }
  };

  const deletePaymentInstallment = async (id: string) => {
    try {
      await deleteDotThanhToan(id);
    } catch (error) {
      console.error('Error deleting payment installment:', error);
      throw error;
    }
  };

  return {
    paymentInstallments,
    isLoading,
    addPaymentInstallment,
    updatePaymentInstallment,
    deletePaymentInstallment,
    refreshPaymentInstallments
  };
};
